/**
 * @generated SignedSource<<44fe15f815a15eb0cc590884296ba82a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Page_Pool",
    "kind": "LinkedField",
    "name": "poolsByViewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Pool",
        "kind": "LinkedField",
        "name": "content",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cardPan",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cardType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recToken",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BillingInfoPaymentCheckoutPagesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BillingInfoPaymentCheckoutPagesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0d0ee3eb61b6eaecfc563ad91fa765aa",
    "id": null,
    "metadata": {},
    "name": "BillingInfoPaymentCheckoutPagesQuery",
    "operationKind": "query",
    "text": "query BillingInfoPaymentCheckoutPagesQuery(\n  $request: PoolsRequestInput\n) {\n  poolsByViewer(request: $request) {\n    content {\n      id\n      cardPan\n      cardType\n      recToken\n    }\n  }\n}\n"
  }
};
})();

node.hash = "23156e4717c138222100de1af1a415b6";

module.exports = node;
